import { Component, OnInit, HostListener, ViewChild } from '@angular/core'; 
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from './app.settings';
import { AppService } from './app.service';
import { Category, Product, LoginRequest } from './app.models';
import { SidenavMenuService } from './theme/components/sidenav-menu/sidenav-menu.service';
import { SidenavMenu } from './theme/components/sidenav-menu/sidenav-menu.model';
import { MatSnackBar } from '@angular/material';


// ******************************************* APP PAGES COMPONENT CLASS *********************************************
@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [ SidenavMenuService ]
})
export class PagesComponent implements OnInit {
  public showBackToTop: boolean = false;
  public categories: Array<Category> = [];
  public category:Category;
  public sidenavMenuItems:Array<any> = [];
  @ViewChild('sidenav', { static: true }) sidenav:any;
  public settings: Settings;
  private currencies: any;


  // -- FUNC Constructor
  constructor(public appSettings:AppSettings, 
              public appService:AppService, 
              public sidenavMenuService:SidenavMenuService,
              public router: Router,
              public snackBar: MatSnackBar) { 
    this.settings = this.appSettings.settings; 
  }


  // -- FUNC Ng On Init
  ngOnInit() {
    this.appService.createInitialUser();
    this.checkAndLoginUser();
    this.getAllCategories();
    this.currencies = this.appService.getCurrencies();
    //this.sidenavMenuItems = this.sidenavMenuService.getSidenavMenuItems();
  } 


  // -- FUNC Check And Login User
  private checkAndLoginUser() {

    localStorage.setItem('isUserLoggedIn', "No");

    if (localStorage.getItem('wasUserLoggedInBefore') == 'Yes') {
      var email = localStorage.getItem('userEmail');
      var password = localStorage.getItem('userPassword');

      //console.log("PREVIOUS LOGIN DATA : " + email + " " + password);

      var loginRequest: LoginRequest = new LoginRequest(email, password, "web");

      this.appService.getSecurityKeyFromApiSaveItAndLoginWithGiveCredentionals("Pages", loginRequest);
    }

  }


  // -- FUNC Get Rate For User Currency
  public getRateForUserCurrency(userCurrencyRate: string) {
    this.appService.getRateForUserCurrency(userCurrencyRate
    ).subscribe(data => {
      // check responce status
      if (data['CNY_' + userCurrencyRate] != '' && data['CNY_' + userCurrencyRate] != 'null') {
        //console.log("TRUE ON GET CURRENCY RATE" + JSON.stringify(data));
      }
      else {
        //console.log("FALSE ON GET CURRENCY RATE");
      }
    });
  }


  // -- FUNC Get All Categories
  public getAllCategories() {

    this.appService.getAllCategories().subscribe(data => {
      // check status and if it is ok then unpack received new products list
      if (data['status'] == 1) {
        //console.log("TRUE ON GET ALL CATEGORIES" + JSON.stringify(data));
        this.categories = <Category[]>data['data'];
        this.category = this.categories[0];
        this.appService.Data.categories = this.categories;
        this.createSideNavMenuItems();
      }
      else {
        //console.log("FALSE ON GET ALL CATEGORIES" + JSON.stringify(data));
      }
    });
  }


  // -- FUNC Create Side Nav Menu Items
  private createSideNavMenuItems() {

        var sidenavMenuItems: Array<any> = [];
        sidenavMenuItems.push(new SidenavMenu(1, 'Главная', '/', null, null, false, 0));
        sidenavMenuItems.push(new SidenavMenu(2, 'Категории', null, null, null, true, 0));

        var menuItemIndex = 2;
    for (var category of this.categories) {
            menuItemIndex += 1;
            var currentMenuItemIndex = menuItemIndex;

            sidenavMenuItems.push(new SidenavMenu(menuItemIndex, category.vName, null, null, null, true, 2));
      for (var subCategory of category.subCategories) {
                menuItemIndex += 1;
                sidenavMenuItems.push(new SidenavMenu(menuItemIndex, subCategory.vName, '/products/'+subCategory.id+'/'+subCategory.vName, null, null, false, currentMenuItemIndex));
          }
        }
        sidenavMenuItems.push(new SidenavMenu(menuItemIndex, 'О магазине', '/about-us', null, null, false, 0))
        sidenavMenuItems.push(new SidenavMenu(menuItemIndex, 'Новости', '/news', null, null, false, 0))
        sidenavMenuItems.push(new SidenavMenu(menuItemIndex, 'Контакты', '/contact', null, null, false, 0))

        this.sidenavMenuItems = sidenavMenuItems;
     
  }


  // -- FUNC Get User Currency Sign
  public getUserCurrencySign() {
    var currency = this.currencies[this.appService.Data.user.currencyId];
    var sign;

    if (currency) {
      sign = currency.sign
    }
    else {
      sign = '¥';
    }

    return sign;

  }


  // -- FUNC Get Cart Total Price
  public getCartTotalPrice(calculatedCartTotalPrice) {
    var appropriateCartTotalPrice = calculatedCartTotalPrice * this.appService.Data.user.currencyRate;
    return appropriateCartTotalPrice;
  }


  // -- FUNC Get Product Price
  public getProductPrice(productPrice) {
    var appropriateProductPrice = productPrice * this.appService.Data.user.currencyRate;
    return appropriateProductPrice;
  }


  // -- FUNC Get Product Discount Price
  public getProductDiscountPrice(productPrice, productDiscountPerc) {
    // Caculate product price with discount
    var calculatedDiscountProductPrice = productPrice * ((100-productDiscountPerc) / 100);
    var appropriateDiscountProductPrice = calculatedDiscountProductPrice * this.appService.Data.user.currencyRate;
    return appropriateDiscountProductPrice;
  }


  /*
  public changeCategory(event){
    if(event.target){
      this.category = this.categories.filter(category => category.name == event.target.innerText)[0];
    }
    if(window.innerWidth < 960){
      this.stopClickPropagate(event);
    } 
  }*/


  // -- FUNC Go To Chekout
  private goToCheckout() {
    // if user is not guest then move to the chekout page 
    if (String(this.appService.Data.user.iUserID) != "2121") {
      this.router.navigate(['/checkout']);
    }
    // else if user is not a guest then tell him that he need to sign-in to proceed
    else {

      if (confirm('Приносим извинения но Вы не Авторизованы в приложении и поэтому не можете перейти к оформлению заказа. Перейти на страницу авторизации?')) {
        this.router.navigate(['/sign-in']);
      }

    }
  }


  // -- FUNC Remove Product
  public removeProduct(product) {
      const index: number = this.appService.Data.cartList.indexOf(product);
      if (index !== -1) {
          this.appService.Data.cartList.splice(index, 1);
          this.appService.Data.totalCartPrice = this.appService.Data.totalCartPrice - product.price*product.cartCount;
          this.appService.Data.totalCartCount = this.appService.Data.totalCartCount - product.cartCount;
      }        
  }


  // -- FUNC Clear Cart
  public clearCart(){
    /*this.appService.Data.cartList.forEach(product => {
      product.cartCount = 0;
    });*/
    this.appService.Data.cartList = [];
    this.appService.Data.totalCartCount = 0;
    this.appService.Data.totalCartPrice = 0;
  }
 

  // -- FUNC Change Theme 
  public changeTheme(theme){
    this.settings.theme = theme;       
  }


  // -- FUNC Stop Click Propagate
  public stopClickPropagate(event: any){
    event.stopPropagation();
    event.preventDefault();
  }


  // -- FUNC Search
  public search() {

    var searchRequest = (<HTMLInputElement>document.getElementById("searchText")).value;

    // check if search reqeust isnt empty and if isnt then perfrom get searched products request
    if (searchRequest != '') {
      this.appService.getSearchedProductsForRequest(searchRequest).subscribe(data => {
        // check status and if it is ok then unpack received searched products list
        if (data['status'] == 1) {
          console.log("TRUE ON GET SEARCHED PRODUCTS" + JSON.stringify(data));
          // save received searched products nad move to the products page
          this.appService.Data.searchedProducts = <Product[]>data['data'];
          this.router.navigate(['/products', 'search', 'найденные товары']);
        }
        else {
          console.log("FALSE ON GET SEARCHED PRODUCTS" + JSON.stringify(data));
          this.snackBar.open('К сожалению по вашему запросу ничего не найдено', '×', { panelClass: 'error', verticalPosition: 'top', duration: 5000 });
        }
      });
    }
  }


  // -- FUNC Scroll To Top
  public scrollToTop(){
    var scrollDuration = 200;
    var scrollStep = -window.pageYOffset  / (scrollDuration / 20);
    var scrollInterval = setInterval(()=>{
      if(window.pageYOffset != 0){
         window.scrollBy(0, scrollStep);
      }
      else{
        clearInterval(scrollInterval); 
      }
    },10);
    if(window.innerWidth <= 768){
      setTimeout(() => { window.scrollTo(0,0) });
    }
  }


  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    ($event.target.documentElement.scrollTop > 300) ? this.showBackToTop = true : this.showBackToTop = false;  
  }


  // -- FUNC Ng After View Init
  ngAfterViewInit(){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) { 
        this.sidenav.close(); 
      }                
    });
    this.sidenavMenuService.expandActiveSubMenu(this.sidenavMenuItems);
  }


  // -- FUNC Close Sub Menus
  public closeSubMenus(){
    if(window.innerWidth < 960){
      this.sidenavMenuService.closeAllSubMenus();
    }    
  }

}
